import { render, staticRenderFns } from "./BookingPayDialog.vue?vue&type=template&id=afb1eae6&"
import script from "./BookingPayDialog.vue?vue&type=script&lang=js&"
export * from "./BookingPayDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports